module.exports = __webpack_public_path__ + "img/datmaLogo.fb6ce9f4.png";